import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import Swal from "sweetalert2";

function MenuUpdateModal({ title, id, onClose, originRows, handleView, menuModalFullOption, menuModalOption }) {
  const appStore = useContext(AppContext);
  const menuNameRef = useRef(null);
  const [inputs, setInputs] = useState({
    menu_id: 0,
    upper_menu_id: 0,
    company_id: 0,
    menu_solution_yn: 'N',
    menu_name: '',
    upper_menu_name:'',
    menu_sort:0,
    before_upper_menu_id:0,
    before_menu_sort:0,
  });

  useEffect(() => {
      // Mount 될때만 실행된다.
  }, [])

  useEffect(() => {
      //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
      handleInitSelect();
  }, [originRows])
  
  const onSelectChange = (type, arrayitem) => {
    
    if(arrayitem.value == inputs.before_upper_menu_id){ // 기존화면에서의 maxsort

      const nextInputs = {
          ...inputs,
          [type] : arrayitem.value,
          ['menu_sort'] : inputs.before_menu_sort
      };
      setInputs(nextInputs);

    } else { // 다른 화면면에서의 maxsort

      const nextInputs = {
          ...inputs,
          [type] : arrayitem.value,
          ['menu_sort'] : arrayitem.maxsort
      };
      setInputs(nextInputs);

    }

  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onSortChange = (e)=>{
    let msg = ''

    menuModalFullOption.map((item,index) =>{
      if(item.upper_menu_id == inputs.upper_menu_id && item.menu_sort == e.target.value){
        if(e.target.value == inputs.before_menu_sort && inputs.upper_menu_id == inputs.before_upper_menu_id){
        } else {
          msg = item.menu_name + ' 이후의 메뉴 순서가 하나씩 밀려납니다.'
        }
        
      }
    })

    menuModalOption.map((item,index) =>{

      if(inputs.upper_menu_id != inputs.before_upper_menu_id){ // 기존과 다른부서에서의 sort
        if(item.value == inputs.upper_menu_id && item.maxsort < e.target.value){
          msg = '선택한 상위화면의 최대정렬 순서는 ' + item.maxsort + ' 입니다.'
          e.target.value = item.maxsort
        }
      } else {
        if(item.value == inputs.upper_menu_id && item.maxsort-1 < e.target.value){ // 기존 부서에서의 sort
          msg = '선택한 상위화면면의 최대정렬 순서는 ' + (item.maxsort-1) + ' 입니다.'
          e.target.value = item.maxsort-1
        }
      }
    })

    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">메뉴 수정 오류</p>',
        text: msg,
        confirmButtonText: '확인'
      });
    }
  };

  const handleInitSelect = () => {
    
    //조회
    setInputs({
      menu_id: String(originRows[0].menu_id),
      upper_menu_id: originRows[0].upper_menu_id,
      company_id: originRows[0].company_id,
      menu_solution_yn: originRows[0].menu_solution_yn,
      menu_name: originRows[0].menu_name,
      upper_menu_name:'',
      menu_sort:originRows[0].menu_nav_exposure_order,
      before_upper_menu_id:originRows[0].upper_menu_id,
      before_menu_sort:originRows[0].menu_nav_exposure_order,
      reg_user_id: originRows[0].reg_user_id,
      reg_user_name: originRows[0].reg_user_name,
      reg_datetime: originRows[0].reg_datetime,
      update_user_id: originRows[0].update_user_id,
      update_user_name: originRows[0].update_user_name,
      update_datetime: originRows[0].update_datetime,
    });

  }

  const handleSave = (event) => {
    // 이름 확인 정규식(2-20 자리 영문소+영문대+한글+띄어쓰기 입력 가능) : !(/^[가-힣a-zA-z\s]{2,20}$/).test(inputs.user_name.trim())
    // ID 확인 정규식(4-20 자리 영문소+영문대+숫자 입력 가능) : !(/^[a-zA-z0-9]{4,20}$/).test(inputs.user_login_id.trim())
    // 날짜 확인 정규식(19@@년도 입력 불가) : !(/^2[0-1]\d{2}-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
    // 날짜 확인 정규식(19@@년도 입력 가능) : !(/^(19\d{2}|2[0-1]\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
    // 휴대폰 정규식(010-숫자4자리-숫자4자리 입력 가능) : !(/^010-\d{4}-\d{4}$/).test(inputs.user_phone.trim())
    // 전화번호 정규식(숫자3자리-숫자4자리-숫자4자리) : !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.user_call.trim())
    // E-Mail 정규식 : !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.user_email.trim())
    // 계좌번호 정규식(숫자, 하이픈 5-30자리 이하) : !(/^[0-9-]{5,30}$/).test(inputs.bank_number.trim())
    
    let msg = '';
    if(inputs.menu_name.trim() === ''){
      msg = '화면명은 필수로 입력 해주세요.';
    }else if(!(/^[가-힣a-zA-z0-9\s]{2,20}$/).test(inputs.menu_name.trim())){
      msg = '화면명 입력이 올바르지 않습니다.\n(입력 양식 : 한글+영문+숫자+띄어쓰기 2~20자리)';
    }else if(inputs.menu_sort === '' || inputs.menu_sort == 0){
      msg = '정렬순서는 필수로 입력 해주세요.';
    }else if(inputs.menu_sort !== '' && !(/^[0-9]{1,2}$/).test(inputs.menu_sort)){
      msg = '정렬순서 입력이 올바르지 않습니다.\n(입력 양식 : 2자리 이하숫자)';
    }else{
      
      axios.post("/api/p/Menu/Update", new URLSearchParams({
        menu_id:inputs.menu_id,
        upper_menu_id:inputs.upper_menu_id,
        menu_name:inputs.menu_name.trim(),
        menu_sort:inputs.menu_sort,
      }),
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          Swal.fire({
            title: '화면 수정 완료',
            text: '정상적으로 화면이 수정 되었습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          }).then((result) => {
            handleInitSelect();
            handleView();
          });
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      })
      .then(function () {
          // 항상 실행
      });
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">화면 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }
  };

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{height: '210px'}}>
          <div>
            <table className="ModalTABLE">
              <tbody>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">화면명<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        {inputs.menu_solution_yn === 'Y'?
                        <input type="text" placeholder="화면명" value={inputs.menu_name} name="menu_name" onChange={(e) => onChange(e) } ref={menuNameRef} autoComplete="off" style={{width: '755px'}} disabled={true} />
                        :
                        <input type="text" placeholder="화면명" value={inputs.menu_name} name="menu_name" onChange={(e) => onChange(e) } ref={menuNameRef} autoComplete="off" style={{width: '755px'}} />}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">상위화면</div>
                      <div className="modal_filed_input">
                        <Select className="modal_filed_input_select" placeholder="상위화면" value={menuModalOption.filter(function (option) { return option.value === inputs.upper_menu_id;  })} onChange={(e) => onSelectChange('upper_menu_id',e)} options={menuModalOption} isDisabled={inputs.before_upper_menu_id===0?true:false} noOptionsMessage={() => "조회되는 항목 없음"} />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">정렬순서<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        {inputs.menu_solution_yn === 'Y'?
                        <input type="text" placeholder="정렬순서" value={inputs.menu_sort} name="menu_sort" onChange={(e) => onSortChange(e) } autoComplete="off" disabled={true} />
                        :
                        <input type="text" placeholder="정렬순서" value={inputs.menu_sort} name="menu_sort" onChange={(e) => onSortChange(e) } autoComplete="off" />
                        }
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_action">
                      <div className="modal_button">
                        <Button 
                          onClick={()=> { onClose?.(); }}
                          className="btn-p"
                          sx={{  
                              m: 1, 
                              fontSize: 15, 
                              color: "white", 
                              borderColor: "#808080", 
                              backgroundColor: "#808080",
                              ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                          }} 
                          variant="outlined">
                          닫기
                        </Button>
                      </div>
                      <div className="modal_button">
                        { inputs.menu_solution_yn === 'Y' || inputs.company_id === 0?
                        <></>: 
                        <Button 
                          onClick={handleSave}
                          className="btn-p btn-u"
                          sx={{  
                              m: 1, 
                              fontSize: 18, 
                              color: "white", 
                              borderColor: "#FF3636", 
                              backgroundColor: "#FF3636",
                              ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                          }} 
                          variant="outlined">
                          수정
                        </Button>
                        }
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </PCModal>
  );
}

export default MenuUpdateModal;